export default __webpack_public_path__ + "static/banner_d-59dc8bbfcef5dfc178ea364c805e89d6.jpg";